import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../MyAppText';

interface Props {
    message: string;
}

export default function FilterDependencyMessage({ message }: Props) {
    const { styles } = useStyles(styleSheet);

    return (
        <View style={styles.container}>
            <MyAppText style={styles.text}>{message}</MyAppText>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingVertical: 16,
    },
    text: {
        flex: 1,
        fontSize: 14,
        color: theme.colors.neutral['400'],
    },
}));
